import './sticky-button.scss';
import Component from '../component/component';

export default class StickyButton extends Component {
    static initSelector: string = '.sticky-button';
    public payButton: HTMLElement;
    public acceptTermsCheckbox: HTMLInputElement;
    public acceptTermsTooltip: HTMLElement;
    constructor(target: HTMLElement) {
        super(target);
        this.payButton = this.element.querySelector('.sticky-button__button');
        this.acceptTermsCheckbox = this.element.querySelector('input[type=checkbox]');
        this.acceptTermsTooltip = document.getElementById('accept-terms-tooltip');
        this.init();
    }

    init(): void {
        if (this.acceptTermsCheckbox) {
            this.payButton.addEventListener('click', () => {
                if (this.acceptTermsTooltip) {
                    if (!this.acceptTermsCheckbox.checked) {
                        this.acceptTermsTooltip.style.visibility = 'visible';
                    } else {
                        this.acceptTermsTooltip.style.visibility = 'hidden';
                    }
                }
            });

            this.acceptTermsCheckbox.addEventListener('change', (event: Event) => {
                const isChecked: boolean = (<HTMLInputElement>event.target).checked;

                if (this.acceptTermsTooltip && isChecked) {
                    this.acceptTermsTooltip.style.visibility = 'hidden';
                }
            });
        }
    }
}
